export const SET_API_HOST = 'SET_API_HOST';
export const setApiHost = text => {
  return {
    type: SET_API_HOST,
    apiHost: text
  };
};
